import { AnalyseDataTableNonHistoricalResponseData, AnalyseDataTableResponseData } from '../analyse';

export function isNonHistoricalResponseData(data: AnalyseDataTableResponseData): data is AnalyseDataTableNonHistoricalResponseData {
  return (data as any).editions !== undefined;
}
